module.exports = "<div class=container><div class=\"progress-striped active loading-progressbar_bar progress\"><div class=progress-bar-label>Please, wait...</div><div class=\"progress-bar progress-bar-success\" ng-style=\"{\r\n                animation: 'progress-bar-stripes 2s linear infinite, animateWidth '+$ctrl.value + 's ',\r\n            }\"></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/loading-progressbar/loading-progressbar.html
// module id = 563
// module chunks = 0